import { divIcon } from "leaflet";
import pointUtilities from "../../utilities/pointUtilities";
import stringUtilities from "../../utilities/stringUtilities";

const dragHandleHtml = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><rect width="10" height="10" stroke="#000" stroke-width="3" fill="#000" /></svg>`;

const dragHandle = divIcon({
    html: dragHandleHtml,
    className: "marker-icon-point move",
    draggable: true,
    iconAnchor: [5, 5],
    iconSize: [10, 10]
});

const dragHandleNesw = divIcon({
    html: dragHandleHtml,
    className: "marker-icon-point nesw",
    draggable: true,
    iconAnchor: [5, 5],
    iconSize: [10, 10]
});

const dragHandleNwse = divIcon({
    html: dragHandleHtml,
    className: "marker-icon-point nwse",
    draggable: true,
    iconAnchor: [5, 5],
    iconSize: [10, 10]
});

const dragHandleNs = divIcon({
    html: dragHandleHtml,
    className: "marker-icon-point ns",
    draggable: true,
    iconAnchor: [5, 5],
    iconSize: [10, 10]
});

const dragHandleEw = divIcon({
    html: dragHandleHtml,
    className: "marker-icon-point ew",
    draggable: true,
    iconAnchor: [5, 5],
    iconSize: [10, 10]
});

const markerIcon = (point, workflows) => {
    let color = pointUtilities.getColorFromPoint(point, workflows);
    let iconUrl = pointUtilities.getIconUrlFromPoint(point, workflows);
    let icon = stringUtilities.isNullOrEmpty(iconUrl) ? divIcon({
        html: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="${ color }" /></svg>`,
        className: "marker-icon-point",
        iconAnchor: [8, 8],
        iconSize: [16, 16]
    }) : divIcon({
        html: `<img src="${ iconUrl }">`,
        className: "marker-icon-point",
        iconAnchor: [15, 15],
        iconSize: [30, 30]
    });

    return icon
}

export default {
    dragHandle,
    dragHandleNesw,
    dragHandleNwse,
    dragHandleNs,
    dragHandleEw,
    markerIcon
}